import { useEffect } from 'react'

/** Inserts JSON-LD into document.head. react-helmet-async does not emit script tags under React 19. */
export default function JsonLd({ data }: { data: unknown }) {
  const payload = JSON.stringify(data)

  useEffect(() => {
    const script = document.createElement('script')
    script.type = 'application/ld+json'
    script.setAttribute('data-jsonld', 'true')
    script.text = payload
    document.head.appendChild(script)
    return () => {
      script.remove()
    }
  }, [payload])

  return null
}
